export default __webpack_public_path__ + "static/media/cypress.d89371f2.svg";